import type {
  InputHTMLAttributes,
  ReactNode,
  SelectHTMLAttributes,
  TextareaHTMLAttributes,
} from "react";
import { inputClass, type InputSize as Size } from "./classes";

export const Input = ({
  inputSize,
  className = "",
  ...props
}: InputHTMLAttributes<HTMLInputElement> & { inputSize?: Size }) => (
  <input className={`${inputClass(inputSize)} ${className}`} {...props} />
);

export const Textarea = ({
  inputSize,
  className = "",
  ...props
}: TextareaHTMLAttributes<HTMLTextAreaElement> & { inputSize?: Size }) => (
  <textarea className={`${inputClass(inputSize)} ${className}`} {...props} />
);

export const Select = ({
  inputSize,
  className = "",
  ...props
}: SelectHTMLAttributes<HTMLSelectElement> & { inputSize?: Size }) => (
  <select className={`${inputClass(inputSize)} ${className}`} {...props} />
);

/** A labelled control: a small muted label above it, and an optional hint. */
export const Field = ({
  label,
  hint,
  children,
  className = "",
}: {
  label: ReactNode;
  hint?: ReactNode;
  children: ReactNode;
  className?: string;
}) => (
  <label className={`block text-xs font-medium text-hazumu-muted ${className}`}>
    {label}
    <span className="mt-1.5 block text-sm font-normal text-hazumu-ink">{children}</span>
    {hint && <span className="mt-1.5 block leading-5 font-normal">{hint}</span>}
  </label>
);

/** A short error under a control. */
export const FieldError = ({ children }: { children: ReactNode }) => (
  <p role="alert" className="mt-1.5 text-xs leading-5 text-hazumu-danger">
    {children}
  </p>
);
